import { documentTabs } from './Document';
import { formModes, counterpartyDocKinds } from '../../constants';
import i18next from "../../i18n";

export function checkInputPage() {
    const checkResult = { error: '', incorrectTab: documentTabs.information };
    const { prop_sx_caDocDate, prop_sx_caDocKind, prop_sx_caDocNumber, formMode, prop_sx_cacontents, prop_sx_caDocMouth, associations, addedContractId, file } = this.state;
    if (!(prop_sx_caDocDate && prop_sx_caDocKind && prop_sx_caDocNumber && prop_sx_cacontents)) {
        checkResult.error = i18next.t('notAllRequiredFildsAreSpecifiedMessage');
    }
    else if ((prop_sx_caDocKind === counterpartyDocKinds.guaranteeLetters || prop_sx_caDocKind === counterpartyDocKinds.supportingDocuments) && !prop_sx_caDocMouth) {
        checkResult.error = i18next.t('notAllRequiredFildsAreSpecifiedMessage');
    }
    else if (prop_sx_caDocKind === counterpartyDocKinds.docC33 && (formMode === formModes.create ? !addedContractId : associations?.universalContractDoc?.length <= 0)) {
        checkResult.error = i18next.t('contractNotAdded');
    }
    else if (!file && !associations?.mainContent?.length > 0) {
        checkResult.error = i18next.t('mainFileNotAdded');
    }
    return checkResult;
}
export function buildFormItem(item) {
    const { prop_sx_caDocKind } = this.state;
    if (["prop_sx_caDocMouth", "caDocMouth_empty"].includes(item.Name) && ![counterpartyDocKinds.guaranteeLetters, counterpartyDocKinds.supportingDocuments].includes(prop_sx_caDocKind)) {
        return null;
    }
    return item;
}